import React from 'react';
import '../styles/TrustBar.css';

const items = [
  'Node.js', 'AWS', 'React', 'PostgreSQL', 'Docker', 'Redis',
  'MITRE ATT&CK', 'Kubernetes', 'Nginx', 'Grafana',
  'OpenSSL', 'Express', 'MongoDB', 'Linux Kernel', 'GitHub Actions',
];

export default function TrustBar() {
  return (
    <div className="trust">
      <p className="trust__head">Technologies we Monitor</p>
      <div className="trust__marquee">
        <div className="trust__track">
          {[...items, ...items, ...items].map((name, i) => (
            <span key={i} className="trust__item">
              <span className="trust__item-dot" />
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
